const listPointsBody = document.querySelector('#viewChats').querySelector('div[name=body]').querySelector('div[name=mainLenta]');

// import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';
import auth from '../../tools/storage.js';

export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index, currentFilmManager) {
    
    let fcID = ` fmID=${item.fmIDfk}  `;
    let manager = item.manager.mail;

    if (item.manager.detail.nameF) {
      manager = item.manager.detail.nameF;

      if (item.manager.detail.nameI)
        manager += ' ' + item.manager.detail.nameI.substring(0, 1) + '. ';

      if (item.manager.detail.nameO)
        manager += ' ' + item.manager.detail.nameO.substring(0, 1) + '.';
    } else if (item.manager.detail.name) {
      manager = item.manager.detail.name;
    }
   
    let newMsg = '';

    if (item.cntUserIDfk)
      newMsg = ' newMsg ';
    
    if (item.fmIDfk == currentFilmManager)
        newMsg += ' currentFilmManager';


    return `<div class="mainLenta-cloud ${newMsg}" ${fcID}> 
            <div ${fcID} class="title"> 
              ${manager}
            </div>  
            <label ${fcID}> ${item.lastchat}</label>
            <little ${fcID}>${item.maxTimeChat}</little>
          </div>`;
  },

  drawDataInContainer(listWithData, currentFilmManager) {
    this.cleanContainer();
    let HTMLBODY = '';

    if (listWithData) {
    
      listWithData.forEach((item, index) => {
        HTMLBODY += this.getElement(item, index, currentFilmManager);
      });
      listPointsBody.innerHTML = HTMLBODY;
    } else
      listPointsBody.innerHTML = ' - - - ';
  },


  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
